export default (obj) => {
  return obj ? Object.keys(obj).reduce((previous, current) => {
    if (previous === '') {
      return `${current}=${obj[current]}`;
    }
    return `${previous}&${current}=${obj[current]}`;
  }, '') : '';
};
